import React from "react";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import "../../assets/css/homepage.css";
import "./../../../src/container/SuperUser/loader.css";
import {
  LoginMobileOtpVerify,
  LoginwithMobile,
  checkActiveSessionMobile,
} from "./../../actions/AuthAction";
import logo from "./../../assets/images/logo.png";
import { default as CONSTANT, default as constant } from "./../../constant";
import { setCookie, setStorage } from "./../../utils";

interface LoginState {
  mobile: string;
  error: {
    mobile: string;
    otp: string;
  };
  timer: number;
  otp: string;
  email: string;
  remember: boolean;
  showModal: boolean;
  passwordShow: boolean;
  password: { name: string; value: string; error: string; isRequired: boolean };
  showLoader: boolean;
  intensity: number;
  otpAttempts: number;
  maxOtpAttempts: number;
  otpExpired: boolean;
  isResending: boolean;
}

class Login extends React.Component<any, LoginState> {
  timerInterval: NodeJS.Timeout | null = null;

  constructor(props: any) {
    super(props);
    this.state = {
      mobile: "",
      error: {
        mobile: "",
        otp: "",
      },
      timer: 300,
      otp: "",
      email: "",
      remember: false,
      showModal: false,
      passwordShow: false,
      password: { name: "password", value: "", error: "", isRequired: true },
      showLoader: false,
      intensity: -20,
      otpAttempts: 0,
      maxOtpAttempts: 3,
      otpExpired: false,
      isResending: false,
    };
  }

  componentWillUnmount() {
    this.clearTimer();
  }

  onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (value.length <= 10) {
      this.setState(
        {
          [name]: value,
        } as any,
        () => {
          if (value.length === 10) {
            const pattern = /^[0-9]{10}$/;
            if (!pattern.test(value)) {
              this.setState((prevState: LoginState) => ({
                error: {
                  ...prevState.error,
                  [name]: "Please enter a valid mobile number",
                },
              }));
            } else {
              this.setState((prevState: LoginState) => ({
                error: {
                  ...prevState.error,
                  [name]: "",
                },
              }));
            }
          } else {
            this.setState((prevState: LoginState) => ({
              error: {
                ...prevState.error,
                [name]: "",
              },
            }));
          }
        }
      );
    }
  };

  startTimer = () => {
    this.clearTimer();
    this.setState({ timer: 300, otpExpired: false });

    this.timerInterval = setInterval(() => {
      this.setState(
        (prevState: LoginState) => ({
          timer: prevState.timer - 1,
        }),
        () => {
          if (this.state.timer === 0) {
            this.setState({ otpExpired: true });
            this.clearTimer();
          }
        }
      );
    }, 1000);
  };

  clearTimer = () => {
    if (this.timerInterval !== null) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  };

  onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { error, mobile, isResending } = this.state;

    if (isResending) return;

    if ((!error || !error.mobile) && mobile && mobile.length === 10) {
      this.setState({
        showLoader: true,
        isResending: true,
        error: { ...this.state.error, otp: "" },
      });

      LoginwithMobile({ mobile: mobile })
        .then((res: any) => {
          if (res.status === "failed") {
            Swal.fire({
              icon: "error",
              text: res?.error,
            });
            this.setState({
              showLoader: false,
              showModal: false,
              isResending: false,
            });
          } else if (res.status === "success") {
            this.setState({
              showLoader: false,
              showModal: true,
              isResending: false,
              otpAttempts: 0,
              otp: "",
            });
            this.startTimer();
          }
        })
        .catch((error: any) => {
          console.error("Error sending OTP:", error);
          this.setState({
            showLoader: false,
            showModal: false,
            isResending: false,
          });
          toast.error("Failed to send OTP. Please try again.");
        });
    } else {
      this.setState((prevState: LoginState) => ({
        error: {
          ...prevState.error,
          mobile: "Mobile number must be 10 digits",
        },
      }));
    }
  };

  formatTime = (time: number) => {
    const minutes = Math.floor(time / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (time % 60).toString().padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  onVerifyOtp = async (e: any) => {
    e.preventDefault();
    const { otp, mobile, otpAttempts, maxOtpAttempts, otpExpired } = this.state;

    this.setState((prevState: LoginState) => ({
      error: {
        ...prevState.error,
        otp: "",
      },
    }));

    if (otpExpired) {
      this.setState((prevState: LoginState) => ({
        error: {
          ...prevState.error,
          otp: "OTP has expired. Please request a new one.",
        },
      }));
      return;
    }

    if (otpAttempts >= maxOtpAttempts) {
      this.setState((prevState: LoginState) => ({
        error: {
          ...prevState.error,
          otp: "Maximum OTP attempts exceeded. Please request a new OTP.",
        },
      }));
      return;
    }

    if (otp.length !== 6) {
      this.setState((prevState: LoginState) => ({
        error: {
          ...prevState.error,
          otp: "Please enter a 6-digit OTP",
        },
      }));
      return;
    }

    this.setState({ showLoader: true });

    try {
      let userActive = await checkActiveSessionMobile({
        mobile: mobile,
        mob_otp: otp,
      });
      if (userActive.status === constant.static.apiStatus.success) {
        Swal.fire({
          title: "Are you sure?",
          text: "User is already logged in. Do you want to proceed?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Let me in",
        }).then((result) => {
          if (result.isConfirmed) {
            LoginMobileOtpVerify({
              mobile: mobile,
              mob_otp: otp,
            }).then((res: any) => {
              if (res.status) {
                if (res.status === CONSTANT.static.apiStatus.success) {
                  const url =
                    res?.result?.userDetail?.designationCode === 370
                      ? CONSTANT.component.dakManagementCreate.url
                      : CONSTANT.component.userFileList.url;
                  setCookie(CONSTANT.cookie.token, res.result.token);
                  setCookie(CONSTANT.cookie.userDetail, res.result.userDetail);
                  setStorage(CONSTANT.cookie.recipients, res.result.recipients);
                  setStorage(
                    CONSTANT.cookie.permissions,
                    res.result.permissions
                  );
                  setStorage(
                    CONSTANT.cookie.hrDealingOfficerList,
                    res.result.hrDealingOfficer
                  );
                  setStorage(
                    CONSTANT.cookie.hrexecutive,
                    res.result.hrExecutive
                  );
                  setStorage(CONSTANT.cookie.finance, res.result.finance);
                  setTimeout(() => {
                    this.setState({ ...this.state, showLoader: false });
                    this.props.history.push(url);
                  }, 3000);
                } else {
                  this.setState({ ...this.state, showLoader: false });
                  toast.error(res.error, {
                    position: "top-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                }
              }
            });
          } else {
            this.setState({ showLoader: false });
          }
        });
      } else {
        LoginMobileOtpVerify({
          mobile: mobile,
          mob_otp: otp,
        }).then((res: any) => {
          if (res.status) {
            if (res.status === CONSTANT.static.apiStatus.success) {
              const url =
                res?.result?.userDetail?.designationCode === 370
                  ? CONSTANT.component.dakManagementCreate.url
                  : CONSTANT.component.userFileList.url;
              setCookie(CONSTANT.cookie.token, res.result.token);
              setCookie(CONSTANT.cookie.userDetail, res.result.userDetail);
              setStorage(CONSTANT.cookie.recipients, res.result.recipients);
              setStorage(CONSTANT.cookie.permissions, res.result.permissions);
              setStorage(
                CONSTANT.cookie.hrDealingOfficerList,
                res.result.hrDealingOfficer
              );
              setStorage(CONSTANT.cookie.hrexecutive, res.result.hrExecutive);
              setStorage(CONSTANT.cookie.finance, res.result.finance);
              setTimeout(() => {
                this.props.history.push(url);
                this.setState({ ...this.state, showLoader: false });
              }, 3000);
            } else {
              this.setState({ ...this.state, showLoader: false });
              toast.error(res.error, {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          }
        });
      }
    } catch (error) {
      console.error("Error checking active session:", error);
      this.setState({ showLoader: false });
      toast.error("An error occurred. Please try again.");
    }
  };

  handleResendOTP = (e: any) => {
    e.preventDefault();
    this.setState({
      showModal: false,
      otpAttempts: 0,
      otp: "",
      error: { ...this.state.error, otp: "" },
    });
    this.clearTimer();
    this.onSubmit(e);
  };

  render() {
    const {
      mobile,
      showLoader,
      error,
      showModal,
      otp,
      timer,
      otpExpired,
      isResending,
      otpAttempts,
      maxOtpAttempts,
    } = this.state;

    return (
      <React.Fragment>
        {!showLoader && (
          <>
            <div className="login-21">
              <div className="container-fluid">
                <div className="row login-box60">
                  <div className="col-lg-5 form-text">
                    <div className="info clearfix">
                      <div className="animate-charcter">
                        <img src={logo} alt="logo" />
                      </div>
                      <p>ई-आफ़िस पोर्टल / e-Office and Intranet Portal</p>
                    </div>
                  </div>
                  <div className="col-lg-7 align-self-center form-section">
                    <div className="form-inner">
                      <h1>eOffice and Intranet Portal</h1>
                      {!showModal ? (
                        <form onSubmit={this.onSubmit}>
                          <div className="form-group form-box">
                            <input
                              disabled={showModal}
                              id="mobile"
                              maxLength={10}
                              className={
                                error?.mobile?.length > 0
                                  ? "form-controll has-validation"
                                  : "form-controll"
                              }
                              placeholder="Enter your 10 digit mobile number"
                              name="mobile"
                              value={mobile}
                              onChange={(e) => {
                                e.target.value = e.target.value
                                  .replace(/\D/g, "")
                                  .slice(0, 10);
                                this.onChange(e);
                              }}
                            />
                            <i className="flaticon-mail-2" />
                            {error?.mobile && (
                              <span className="text-danger ml-1">
                                {error.mobile}
                              </span>
                            )}
                          </div>
                          <div className="form-group">
                            <button
                              type="submit"
                              disabled={isResending}
                              className="btn-md btn-theme w-100"
                            >
                              {isResending ? "SENDING OTP..." : "GET OTP"}
                            </button>
                          </div>
                        </form>
                      ) : (
                        <form
                          onSubmit={(e) => {
                            this.onVerifyOtp(e);
                          }}
                        >
                          <div className="form-group form-box">
                            <NumberFormat
                              id="otp"
                              value={otp}
                              className={
                                error?.otp
                                  ? "form-controll has-validation"
                                  : "form-controll"
                              }
                              onChange={(e: any) => {
                                if (e.target.value.length <= 6) {
                                  this.setState({
                                    otp: e.target.value,
                                    error: { ...this.state.error, otp: "" },
                                  });
                                }
                              }}
                              name="otp"
                              placeholder="Enter 6-digit OTP sent to your mobile"
                              disabled={
                                otpExpired ||
                                (otpAttempts >= maxOtpAttempts &&
                                  !error?.otp?.includes("attempt(s) remaining"))
                              }
                            />
                            {error?.otp && (
                              <div className="mt-2">
                                <span className="text-danger">
                                  <strong>{error.otp}</strong>
                                </span>
                                {error.otp.includes("attempt(s) remaining") && (
                                  <div className="mt-1">
                                    <small style={{ color: "orange" }}>
                                      Please check your OTP and try again
                                      carefully.
                                    </small>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>

                          <div className="mb-3">
                            {otpExpired ? (
                              <span style={{ color: "crimson" }}>
                                OTP has expired.
                                <Link
                                  className="text-primary ml-1"
                                  style={{ cursor: "pointer" }}
                                  href="#"
                                  onClick={this.handleResendOTP}
                                >
                                  REQUEST NEW OTP
                                </Link>
                              </span>
                            ) : timer <= 60 ? (
                              <span style={{ color: "orange" }}>
                                OTP expires in {this.formatTime(timer)}.
                                <Link
                                  className="text-primary ml-1"
                                  style={{ cursor: "pointer" }}
                                  href="#"
                                  onClick={this.handleResendOTP}
                                >
                                  RESEND OTP
                                </Link>
                              </span>
                            ) : (
                              <span style={{ color: "chocolate" }}>
                                Request new OTP in {this.formatTime(timer)}
                              </span>
                            )}
                          </div>

                          <span style={{ color: "darkcyan" }} className="fs-18">
                            An OTP has been sent to {mobile}. You may not
                            receive the OTP if the number is not registered with
                            us.
                          </span>

                          <div className="form-group mt-3">
                            <button
                              type="submit"
                              disabled={
                                otpExpired ||
                                otp.length !== 6 ||
                                (otpAttempts >= maxOtpAttempts &&
                                  !error?.otp?.includes("attempt(s) remaining"))
                              }
                              className="btn-md btn-theme w-100"
                            >
                              LOGIN
                            </button>
                          </div>
                        </form>
                      )}
                      <div className="clearfix" />
                      <div className="extra-login form-group clearfix">
                        <span>OR</span>
                      </div>
                      <div className="clearfix" />
                      <div className="form-group">
                        <Link
                          className="btn-md btn-otp"
                          to={constant.component.home.url}
                        >
                          Back to login
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {showLoader && (
          <div
            className="d-flex justify-center align-items-center"
            style={{ height: "100vh", background: "black" }}
          >
            <div>
              <span className="loader"></span>
            </div>
          </div>
        )}
        <ToastContainer />
      </React.Fragment>
    );
  }
}

export default Login;
